/* Shared text variant classes for CSS module consumers */

.titleLarge {
  font-family: var(--fonts-heading);
  font-weight: var(--font-weights-semi-bold);
  font-size: var(--font-sizes-500);
  --line-height: var(--line-heights-300);
  line-height: var(--line-height);
  letter-spacing: -0.0075em;
  margin: 0;
  -webkit-text-size-adjust: none;
}

.titleMedium {
  font-family: var(--fonts-heading);
  font-weight: var(--font-weights-semi-bold);
  font-size: var(--font-sizes-400);
  --line-height: var(--line-heights-250);
  line-height: var(--line-height);
  letter-spacing: -0.0075em;
  margin: 0;
  -webkit-text-size-adjust: none;
}

.titleSmall {
  font-family: var(--fonts-heading);
  font-weight: var(--font-weights-semi-bold);
  font-size: var(--font-sizes-200);
  --line-height: var(--line-heights-200);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.subtitleLarge {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-100);
  --line-height: var(--line-heights-200);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.subtitleMedium {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-95);
  --line-height: var(--line-heights-200);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.subtitleSmall {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-70);
  --line-height: var(--line-heights-100);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.header {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-medium);
  font-size: var(--font-sizes-90);
  --line-height: var(--line-heights-100);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.primary {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-80);
  --line-height: var(--line-heights-100);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.secondary {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-60);
  --line-height: var(--line-heights-50);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.body {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-70);
  --line-height: var(--line-heights-100);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.link {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-medium);
  font-size: var(--font-sizes-70);
  --line-height: var(--line-heights-100);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.linkSmall {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-medium);
  font-size: var(--font-sizes-60);
  --line-height: var(--line-heights-100);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}

.caption {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-medium);
  font-size: var(--font-sizes-50);
  --line-height: var(--line-heights-50);
  line-height: var(--line-height);
  margin: 0;
  -webkit-text-size-adjust: none;
}
